import React, { useState } from "react";

const useErrorPopup = (errors) => {
  const [isVisible, setIsVisible] = useState(false);

  // Show the popup
  const show = () => setIsVisible(true);

  // Hide the popup
  const hide = () => setIsVisible(false);

  // Popup Component
  const PopupComponent = () => {
    return (
      isVisible && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={hide} // Close popup when clicking outside
          ></div>
          {/* Popup Content */}
          <div className="relative bg-background p-4 rounded-lg shadow-lg z-50 max-w-md w-full">
            <button
              onClick={hide}
              className="absolute top-3 right-1.5 text-secondary/90 hover:text-secondary/60 text-2xl leading-5 mr-2 bg-secondary/10 px-2 pb-1 pt-0.5 rounded-lg"
            >
              &times;
            </button>
            {/* Table */}
            <h2 className="text-lg text-secondary/95 font-bold mb-2">
              Error Details
            </h2>
            {/* Scrollable Table Container */}
            <div className="overflow-x-auto max-h-[400px]">
              <table className="min-w-full bg-secondary/5 border border-secondary/10 rounded-lg">
                <thead>
                  <tr className="bg-secondary/10 text-secondary/95">
                    <th className="py-2 px-4 border-b border-secondary/10 whitespace-nowrap">
                      Row
                    </th>
                    <th className="py-2 px-4 border-b border-secondary/10 whitespace-nowrap">
                      Error
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {errors?.length > 0 ? (
                    errors?.map((item, index) => (
                      <tr key={index} className="border-b border-secondary/5">
                        <td className="py-2 px-4 text-secondary/90 whitespace-nowrap">
                          {item.row}
                        </td>
                        <td className="py-2 px-4 text-secondary/90 whitespace-nowrap">
                          {item.error}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="py-2 px-4 text-center">
                        No errors to display.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    );
  };

  return { show, hide, PopupComponent };
};

export default useErrorPopup;
